import RegistrationStart from "../registration/RegistrationStart";

import {
  Box,
  Container,
  Typography,
  Link
} from '@mui/material';
import UserAvatarMenu from '../../components/auth/UserAvatarMenu';
import { useAuth } from '../../components/auth/AuthContext';

export default function CityWideHousingSolutions() {
  const { showAuthDialog, currentUser } = useAuth();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <UserAvatarMenu />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '100vh',
            py: { xs: 8, md: 16 },
            px: { xs: 2, md: 8 },
            textAlign: { xs: 'center', sm: 'left' }
          }}
        >
          <Typography 
            variant="h2" 
            component="h1" 
            fontWeight="bold" 
            sx={{ 
              mb: 4, 
              fontSize: { xs: '2rem', md: '3rem', lg: '4rem' },
              lineHeight: 1.2 
            }}
          >
            CityWide Housing Solutions
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', maxWidth: 'md' }}>
            <RegistrationStart />
          </Box>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Don't have a passcode?{' '}
              <Link href="/faq" underline="hover" fontWeight="medium">
                Check our FAQ
              </Link>
              {' '}for help getting started.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}